export const Prices = [
  {
      _id: 0,
      name: "0 to ₹100",
      array: [0, 100],
  },
  {
      _id: 1,
      name: "₹100 to ₹1000",
      array: [100, 1000],
  },
  {
      _id: 2,
      name: "₹1000 to ₹5000",
      array: [1000, 5000],
  },
  {
      _id: 3,
      name: "₹5000 to ₹10000",
      array: [5000, 10000],
  },
  {
      _id: 4,
      name: "Above ₹10000",
      array: [10000, 100000],
  },
];
